<template>
  <div class="main-container">
    <div class="bread">
      <router-link :to="{ name: 'MemberTest' }">我的考试</router-link>
      <span class="slash">/</span>
      <span class="current">{{ scantron.title }}</span>
    </div>
    <div class="main-content clearfix">
      <div class="f-left">
        <template v-if="current">
          <div class="back-white">
            <div class="paper-title" :title="scantron.title">
              {{ scantron.title }}
            </div>
            <div class="divider-content">
              <div class="divider"></div>
              <div class="test-introduce">
                <div
                  v-for="item in introduce"
                  :key="item.id"
                  style="z-index: 10; background: #fff; padding: 0 5px"
                >
                  <label class="label">{{ item.label }}：</label>
                  <span class="value">{{ item.value }}{{ item.unit }}</span>
                </div>
              </div>
            </div>
            <template
              v-if="
                section[current.question_id] && scantron.data.length > 1
              "
            >
              <div class="section-name">
                {{ section[current.question_id].name }}
              </div>
              <div class="section-introduce">
                {{ section[current.question_id].introduce }}
              </div>
            </template>
            <Question
              :ques="current"
              :answer="answer"
              :isFile="1"
              :readonly="
                this.$store.state.questionModeSelect == 2 &&
                current.is_confirm == 1
              "
              :hasAnalysis="
                this.$store.state.questionModeSelect == 2 &&
                current.is_confirm == 1
              "
              :showAnalysisBtn="false"
              :showAnswerBtn="true"
              shotAnswerEditable
              showOperate
              :answerImg="answerImg"
              @addImg="addImg"
              @deleteImg="deleteImg"
              :testModel="true"
              :reportId="id"
              @change="onChange(current)"
            ></Question>
          </div>
        </template>
      </div>
      <div ref="rightWrap" class="f-right" :style="style">
        <TestDoRight
          ref="right"
          :reportId="id"
          :scantron="scantron"
          :answer="answer"
          :answerImg="answerImg"
          :limitTime="paper.limit_time"
          hasSection
          shotAnswerEditable
          @topicChange="onTopicChange"
          @submit="submit"
        ></TestDoRight>
      </div>
    </div>
  </div>
</template>
<script>
import Question from "@/components/ques/Question.vue";
import TestDoRight from "./components/TestDoRight.vue";

export default {
  name: "TestDo",
  components: {
    Question,
    TestDoRight,
  },
  data() {
    return {
      introduce: [
        {
          label: "答卷时长",
          value: "",
          id: "time",
          unit: "分钟",
        },
        {
          label: "考试分数",
          value: "",
          id: "score",
          unit: "分",
        },
        {
          label: "通过分数",
          value: "",
          id: "pass_score",
          unit: "分",
        },
      ],
      package_id: this.$route.query.package_id, //试卷的test id
      id: this.$route.query.id, //report id
      answer: {},
      current: {},
      scantron: {},
      answerImg: {},
      section: {},
      paper: {},
      scantronQuestions: [],
      index: 1,
      fixed: 0,
      fixedRight: 0,
    };
  },
  computed: {
    style() {
      let style = {};
      style.right = this.fixedRight + "px";
      if (this.fixed == 1) {
        style.position = "fixed";
        style.top = "70px";
      } else if (this.fixed == 2) {
        style.position = "absolute";
        style.bottom = "0";
      }
      return style;
    },
  },
  watch: {
    "current.is_sign": {
      handler() {
        this.scantronQuestions.find(
          q => q.question_id == this.current.question_id,
        ).is_sign = this.current.is_sign;
      },
    },
  },
  async created() {
    const res = await this.$http.get(
      `/api/app/test/entranceTest/${this.package_id}`,
    );
    res.time = res.time / 60; //答卷时长，单位是秒
    this.introduce.forEach(i => {
      if (i.id == "time" && !res[i.id]) {
        i.value = "不限制";
        i.unit = "";
      } else {
        i.value = res[i.id];
      }
    });
    this.paper = {
      limit_time: res.time * 60,
    };
    await this.getTopicStatus();
    this.$nextTick(() => {
      this.$refs.right.init(this.index);
    });
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener("scroll", this.setFixed);
      document.addEventListener("resize", this.setFixed);
    });
  },
  destroyed() {
    document.removeEventListener("scroll", this.setFixed);
    document.removeEventListener("resize", this.setFixed);
  },
  methods: {
    setFixed() {
      let $ = window.$;
      let scrollTop = $(document.documentElement).scrollTop();
      if (scrollTop > 48) {
        let footerOffset = $("#footerBar").offset();
        let rightHeight = this.$refs.rightWrap.clientHeight;
        if (footerOffset.top - rightHeight - scrollTop < 100) {
          this.fixed = 2;
          this.fixedRight = 0;
        } else {
          this.fixed = 1;
          this.fixedRight = ($(window).width() - 1200) / 2;
          if (this.fixedRight < 0) {
            this.fixedRight = 0;
          }
        }
      } else {
        this.fixed = 0;
      }
    },
    async getTopicStatus() {
      let data = await this.$http.post("/api/app/practice/scantron", {
        report_id: this.id,
        type: 2,
      });
      let list = [];
      data.data.forEach(t => {
        t.child.forEach((ques, index) => {
          list.push(ques);
          if (index == 0) {
            this.$set(this.section, ques.question_id, {
              name: t.name,
              introduce: t.introduce,
            });
          }
        });
      });
      let answerCount = list.filter(t => t.status == 1 || t.status == 2).length;
      if (answerCount > 0) {
        let quesFirst = list.find(q => q.status == 3);
        if (quesFirst) {
          this.index = quesFirst.sort;
        }
      }
      this.scantron = data;
      this.scantronQuestions = list;
      // 全部模式
      this.$store.commit("setQuestionMode", data.practise_module);
      // 当前模式
      this.$store.commit("setQuestionModeSelect", data.mode);
    },
    addImg(ques, path) {
      let images = this.answerImg[ques.question_id] || [];
      images.push(path);
      this.$set(this.answerImg, ques.question_id, images);
    },
    deleteImg(ques, index) {
      this.answerImg[ques.question_id].splice(index, 1);
    },
    onTopicChange(ques) {
      this.scantronQuestions.find(
        q => q.question_id == ques.question_id,
      ).status = ques.status;
      if (ques.ques_type == 1 || ques.ques_type == 2) {
        this.$set(this.answer, ques.question_id, ques.user_answer);
      } else if (ques.ques_type == 3 || ques.ques_type == 4) {
        this.$set(
          this.answer,
          ques.question_id,
          ques.user_answer
            ? ques.user_answer.split(",").map(s => Number(s))
            : [],
        );
      } else if (ques.ques_type == 7) {
        this.$set(
          this.answer,
          ques.question_id,
          ques.user_answer
            ? ques.user_answer.split("@@")
            : ques.right_answer.map(() => ""),
        );
      } else if (ques.ques_type == 5) {
        //简答题
        if (ques.user_answer) {
          let user_answer = JSON.parse(ques.user_answer);
          this.$set(this.answer, ques.question_id, user_answer.content);
          this.$set(this.answerImg, ques.question_id, user_answer.images);
        }
      }
      console.log(566,ques)
      this.$set(this, "current", ques);
    },
    onChange(ques) {
      if (ques.ques_type == 1 || ques.ques_type == 2) {
        if (this.answer[ques.question_id]) {
          this.scantronQuestions.find(
            q => q.question_id == ques.question_id,
          ).status = 1;

          // examDoRight.vue内部监听状态进行练习模式出答案
          if (this.$store.state.questionModeSelect == 2 && !ques.is_confirm) {
            this.$store.commit("setShowQuestionAnswer", {
              is_confirm: 1,
              get: true,
            });
          } else {
            this.$refs.right.navNext();
          }
        }
      } else if (ques.ques_type == 3 || ques.ques_type == 4) {
        if (this.answer[ques.question_id].length > 0) {
          this.scantronQuestions.find(
            q => q.question_id == ques.question_id,
          ).status = 1;
        } else {
          this.scantronQuestions.find(
            q => q.question_id == ques.question_id,
          ).status = 3;
        }
      } else if (ques.ques_type == 7) {
        if (this.answer[ques.question_id].some(Boolean)) {
          this.scantronQuestions.find(
            q => q.question_id == ques.question_id,
          ).status = 1;
        } else {
          this.scantronQuestions.find(
            q => q.question_id == ques.question_id,
          ).status = 3;
        }
      } else if (ques.ques_type == 5) {
        //简答题
        if (
          this.answer[ques.question_id] ||
          (this.answerImg[ques.question_id] || []).length > 0
        ) {
          this.scantronQuestions.find(
            q => q.question_id == ques.question_id,
          ).status = 1;
        } else {
          this.scantronQuestions.find(
            q => q.question_id == ques.question_id,
          ).status = 3;
        }
      }
    },
    submit() {
      this.$router.replace({
        name: "TestReport",
        params: {
          id: this.$route.query.id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  overflow: hidden;
}
.main-content {
  margin-bottom: 30px;
  position: relative;
  > .f-left {
    width: 890px;
    border-radius: 5px;

    .back-white {
      background-color: white;
    }

    /deep/ {
      .el-scrollbar__wrap {
        border-radius: 5px;
      }
      .el-scrollbar__view {
        background-color: white;
        border-radius: 5px;
      }
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
      .el-scrollbar__thumb {
        background-color: #bfbfbf;
      }
    }
  }
  > .f-right {
    width: 290px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    padding: 19px 20px;
    box-sizing: border-box;
  }
}
.paper-title {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #333;
  text-align: center;
  padding: 24px 0 12px 0;
  height: 26px;
  line-height: 26px;
  margin-left: 45px;
  max-width: 800px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.divider-content {
  position: relative;
  margin: 0 20px;
  .test-introduce {
    margin: 0 96px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
    height: 24px;
    .label {
      display: inline-block;
    }
    .value {
      color: #333;
    }
  }
  .divider {
    height: 1px;
    width: 100%;
    border-bottom: 1px dashed #cbcbcb;
    position: absolute;
    top: 11px;
    left: 0;
  }
}
.section-name {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 1;
  padding: 21px 0 0 32px;
}
.section-introduce {
  font-size: 14px;
  color: rgba(128, 128, 128, 1);
  line-height: 1;
  padding: 20px 0 0 32px;
}
</style>
